import { NgModule, Injectable, defineInjectable, inject } from '@angular/core';
import { partialRight, trim } from 'lodash';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class CommonServicesModule {
}
CommonServicesModule.ɵfac = function CommonServicesModule_Factory(t) { return new (t || CommonServicesModule)(); };
CommonServicesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CommonServicesModule });
CommonServicesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CommonServicesModule, [{
        type: NgModule,
        args: [{}]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ConditioningService {
    constructor() {
        this._emailSplitPattern = '[\\s,;]';
    }
    /**
     * condition time to two digit time
     * @param {?} value
     * @return {?}
     */
    padTime(value) {
        if ((value !== undefined) && (value !== null) && (value % 1 === 0) && (value < 60) && (value >= 0)) {
            const /** @type {?} */ retValue = '0' + value;
            return retValue.slice(-2);
        }
        return undefined;
    }
    /**
     * splits a zip-zipext into their component parts.
     * @param {?} input
     * @return {?}
     */
    parseZipParts(input) {
        if (!input) {
            input = '';
        }
        const /** @type {?} */ ret = { zip: '', zip4: '' };
        const /** @type {?} */ index = input.indexOf('-');
        if (index >= 0) {
            ret.zip = input.substr(0, index);
            ret.zip4 = input.substr(index + 1);
        }
        else if (input.length > 5 && Number.isInteger(Number.parseInt(input))) {
            ret.zip = input.substr(0, 5);
            ret.zip4 = input.substr(5);
        }
        else {
            ret.zip = input;
        }
        return ret;
    }
    /**
     * splits a name by spaces returning the first element as the first name
     * and the reset of the elements merged back together as the last name.
     * @param {?} name
     * @return {?}
     */
    parseNames(name) {
        if (!name) {
            name = '';
        }
        const /** @type {?} */ nameParts = { firstName: '', lastName: '' };
        const /** @type {?} */ names = name.split(' ');
        if (names && names.length > 0) {
            nameParts.firstName = names[0];
            delete names[0];
            nameParts.lastName = names.join(' ').trim();
        }
        else {
            nameParts.firstName = name;
        }
        return nameParts;
    }
    /**
     * @param {?=} proNumber
     * @param {?=} digits
     * @return {?}
     */
    conditionProNumber(proNumber = '', digits = 9) {
        if (proNumber === '' || proNumber === null) {
            return '';
        }
        proNumber = this.clean(proNumber);
        proNumber = this.convert(proNumber, digits);
        return proNumber;
    }
    /**
     * @param {?} input
     * @param {?=} tagExceptions
     * @return {?}
     */
    removeHtmlFromString(input, tagExceptions) {
        let /** @type {?} */ exceptionString = '[^<>]{1,}';
        if (tagExceptions) {
            tagExceptions.forEach(tag => {
                let /** @type {?} */ modifiedTag = tag;
                if (!modifiedTag.startsWith('<')) {
                    modifiedTag = `<${modifiedTag}`;
                }
                if (!modifiedTag.endsWith('>')) {
                    modifiedTag = `${modifiedTag}>`;
                }
                exceptionString = `${exceptionString}[^${modifiedTag}]{1,}`;
            });
        }
        const /** @type {?} */ regexp = new RegExp(`<{1}${exceptionString}>{1}`, 'g');
        return input.replace(regexp, '');
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    conditionEmailGroup(inputValue) {
        if (!inputValue) {
            return undefined;
        }
        return inputValue.split(new RegExp(this._emailSplitPattern, 'g')).map(item => item.trim()).filter(item => !!item);
    }
    /**
     * @param {?} proNumber
     * @return {?}
     */
    clean(proNumber) {
        return proNumber.replace(/\D/g, '');
    }
    /**
     * @param {?=} proNumber
     * @param {?=} digits
     * @return {?}
     */
    convert(proNumber = '', digits = 9) {
        let /** @type {?} */ part1, /** @type {?} */ part2, /** @type {?} */ trim$$1, /** @type {?} */ trimmed;
        trim$$1 = partialRight(this.trim.bind(this), '0', 'g', digits);
        trimmed = trim$$1(proNumber);
        if (trimmed.length < 9) { // if it had a leading 0 as part of the real number
            // if it had a leading 0 as part of the real number
            if (trimmed.length < 8) {
                trimmed = `00${trimmed}`;
            }
            else {
                trimmed = `0${trimmed}`;
            }
        }
        part1 = trimmed.slice(0, 3);
        part2 = trimmed.slice(3);
        part2 = (part2.length > 6) ? trim$$1(part2) : part2;
        let /** @type {?} */ retValue = '';
        if (digits === 11) {
            retValue = `0${part1}0${part2}`;
        }
        else if (digits === 10) {
            retValue = `${part1}-${part2}`;
        }
        else {
            retValue = part1.concat(part2);
        }
        return retValue;
    }
    /**
     * @param {?=} string
     * @param {?=} what
     * @param {?=} flags
     * @return {?}
     */
    trim(string = '', what = ',', flags = 'g') {
        let /** @type {?} */ escaped, /** @type {?} */ find;
        escaped = what.replace(/[\[\](){}?*+\^$\\.|\-]/g, '\\$&');
        find = new RegExp('^[' + escaped + ']', flags);
        return string.replace(find, '');
    }
    /**
     * @param {?} errorMsg
     * @return {?}
     */
    sliceError(errorMsg) {
        if (typeof errorMsg === 'string') {
            return errorMsg.replace(/.*?:/, '').slice(0, -1).trim();
        }
        else {
            return '';
        }
    }
}
ConditioningService.ɵfac = function ConditioningService_Factory(t) { return new (t || ConditioningService)(); };
ConditioningService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ConditioningService, factory: ConditioningService.ɵfac, providedIn: 'root' });
/** @nocollapse */ ConditioningService.ngInjectableDef = defineInjectable({ factory: function ConditioningService_Factory() { return new ConditioningService(); }, token: ConditioningService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConditioningService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const ValidationRegexPatterns = {
    tractorPattern: '^[0-9]{3}[-]{1}[0-9]{1,7}$',
    numberTrailerPattern: '^[0-9]{3}[-]{1}[0-9]{1,7}$',
    letterTrailerPattern: '^[a-zA-Z]{1,4}[-]{1}[0-9]{0,6}$',
    numberCheck: '^[0-9]+$',
    doorPattern: '^[0-9]{1,4}$',
    nineDigitPro: '^[0-9]{9}$',
    tenDigitPro: '^[0-9]{3}[-][0-9]{6}$',
    elevenDigitPro: '^[0][0-9]{3}[0][0-9]{6}$',
    emailValidationPattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$',
    phoneNumberPattern: '^\\(?([0-9]{0,3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$',
    multiEmailsPattern: '^(\\s*,?\\s*[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\\w]*[0-9a-zA-Z]\\.)+[a-zA-Z]{2,9})+\\s*$',
    usZipCode: '^(\\d{5}-\\d{4}|\\d{5}|\\d{9})$',
    caPostalCode: '^([a-zA-Z]\\d[a-zA-Z]( )?\\d[a-zA-Z]\\d)$',
    mxPostalCode: '^\\d{5}$',
    madCodeValidationPattern: '^[A-Za-z]{3}[A-Za-z\\s]{2}([A-Za-z]{3}|[0-9]{3})[0-9]{3}$',
    billToMadCodeValidationPattern: '^[A-Za-z]{3}[A-Za-z\\s]{2}(991)[0-9]{3}$',
    sicValidationPattern: '^[A-Za-z]{3}$',
    nmfcValidationPattern: '^[0-9]{4,6}?(-[0-9]{1,2})?$',
    callNumber: '^([0]?[1-9]|[12]\\d|3[01])[-][0-9]{1,4}$',
    routeName: '^[0-9a-zA-Z]{1,5}[-][0-9a-zA-Z]{1,5}$',
    tractorInputValidatorPattern: '^[0-9-]$',
    trailerInputValidatorPattern: '^[0-9a-zA-Z-]$',
    dollyInputValidatorPattern: '^[0-9-]$',
    loadReleaseNumberInputValidatorPattern: '^[0-9]$',
    dateInputValidatorPattern: '^[0-9/]$',
    timeInputValidatorPattern: '^[0-9:]$',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FormatValidationService {
    /**
     * @param {?} conditioningService
     */
    constructor(conditioningService) {
        this.conditioningService = conditioningService;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.numberTrailerPattern = ValidationRegexPatterns.numberTrailerPattern;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.letterTrailerPattern = ValidationRegexPatterns.letterTrailerPattern;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.numberCheck = ValidationRegexPatterns.numberCheck;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.doorPattern = ValidationRegexPatterns.doorPattern;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.nineDigitPro = ValidationRegexPatterns.nineDigitPro;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.tenDigitPro = ValidationRegexPatterns.tenDigitPro;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.elevenDigitPro = ValidationRegexPatterns.elevenDigitPro;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.emailValidationPattern = ValidationRegexPatterns.emailValidationPattern;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.phoneNumberPattern = ValidationRegexPatterns.phoneNumberPattern;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.multiEmailsPattern = ValidationRegexPatterns.multiEmailsPattern;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.usZipCode = ValidationRegexPatterns.usZipCode;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.caPostalCode = ValidationRegexPatterns.caPostalCode;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.mxPostalCode = ValidationRegexPatterns.mxPostalCode;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.madCodeValidationPattern = ValidationRegexPatterns.madCodeValidationPattern;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.billToMadCodeValidationPattern = ValidationRegexPatterns.billToMadCodeValidationPattern;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.sicValidationPattern = ValidationRegexPatterns.sicValidationPattern;
        /**
         * @deprecated Use ValidationRegexPatterns instead
         */
        this.nmfcValidationPattern = ValidationRegexPatterns.nmfcValidationPattern;
        this._emailSplitPattern = '[\\s,;]';
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidEmail(inputValue) {
        if (!inputValue) {
            return false;
        }
        const /** @type {?} */ regExp = new RegExp(ValidationRegexPatterns.emailValidationPattern, 'i');
        return regExp.test(inputValue);
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidEmails(inputValue) {
        if (Array.isArray(inputValue)) {
            return inputValue.every(value => this.isValidEmail(value));
        }
        return this.isValidEmails(this.splitEmailGroup(inputValue));
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    splitEmailGroup(inputValue) {
        if (!inputValue) {
            return undefined;
        }
        return inputValue.split(new RegExp(this._emailSplitPattern, 'g')).map(item => item.trim()).filter(item => !!item);
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidProNumber(inputValue) {
        return this.isValidProNumberCheckDigit(inputValue);
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidCallNumber(inputValue) {
        return new RegExp(ValidationRegexPatterns.callNumber).test(inputValue);
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidRouteName(inputValue) {
        return new RegExp(ValidationRegexPatterns.routeName).test(inputValue);
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidDoorNumber(inputValue) {
        const /** @type {?} */ regExp = new RegExp(ValidationRegexPatterns.doorPattern);
        return regExp.test(inputValue);
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidMexicoPostalCode(inputValue) {
        return new RegExp(ValidationRegexPatterns.mxPostalCode).test(inputValue);
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidUsZipCode(inputValue) {
        return new RegExp(ValidationRegexPatterns.usZipCode).test(inputValue);
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidCanadianPostalCode(inputValue) {
        return new RegExp(ValidationRegexPatterns.caPostalCode).test(inputValue);
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidTrailerNumber(inputValue) {
        const /** @type {?} */ numberTrailerRegExp = new RegExp(ValidationRegexPatterns.numberTrailerPattern).test(inputValue);
        const /** @type {?} */ letterTrailerRegExp = new RegExp(ValidationRegexPatterns.letterTrailerPattern).test(inputValue);
        return numberTrailerRegExp || letterTrailerRegExp;
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidTractorNumber(inputValue) {
        return new RegExp(ValidationRegexPatterns.tractorPattern).test(inputValue);
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    isValidProNumberCheckDigit(inputValue) {
        const /** @type {?} */ proNumber = this.conditioningService.conditionProNumber(inputValue);
        if (proNumber === '' || proNumber.length < 9 || proNumber.length > 11) {
            return false;
        }
        // divide first 8 chars by 7 multiple remainder by 7
        const /** @type {?} */ checkDigit = Number(proNumber.substring(8));
        const /** @type {?} */ number = Number.parseInt(proNumber.substring(0, 8));
        const /** @type {?} */ mod = (number % 7);
        return (mod === checkDigit);
    }
    /**
     * @param {?} inputValue
     * @return {?}
     */
    proNumberCheckDigit(inputValue) {
        const /** @type {?} */ proNumber = this.conditioningService.conditionProNumber(inputValue);
        if (proNumber === '' || proNumber.length < 9 || proNumber.length > 11) {
            return false;
        }
        return true;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isSicValid(value) {
        return value != null && value.length === 3 && new RegExp(ValidationRegexPatterns.sicValidationPattern).test(value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isMadCodeValid(value) {
        return value != null && value.length === 11 && new RegExp(ValidationRegexPatterns.madCodeValidationPattern).test(value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isBillToMadCodeValid(value) {
        return value != null && value.length === 11 && new RegExp(ValidationRegexPatterns.billToMadCodeValidationPattern).test(value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isValidNumeric(value) {
        return value != null && trim(value).length > 0 && !isNaN(value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isValidAlphaNumeric(value) {
        return value != null && /^[a-z0-9]+$/i.test(value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    containsLetters(value) {
        return value != null && /[a-z]/i.test(value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isNmfcValid(value) {
        return value != null && value.length >= 4 && new RegExp(ValidationRegexPatterns.nmfcValidationPattern).test(value);
    }
}
FormatValidationService.ɵfac = function FormatValidationService_Factory(t) { return new (t || FormatValidationService)(ɵngcc0.ɵɵinject(ConditioningService)); };
FormatValidationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FormatValidationService, factory: FormatValidationService.ɵfac, providedIn: 'root' });
/** @nocollapse */
FormatValidationService.ctorParameters = () => [
    { type: ConditioningService }
];
/** @nocollapse */ FormatValidationService.ngInjectableDef = defineInjectable({ factory: function FormatValidationService_Factory() { return new FormatValidationService(inject(ConditioningService)); }, token: FormatValidationService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormatValidationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConditioningService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { CommonServicesModule, ValidationRegexPatterns, ConditioningService, FormatValidationService };

